import React, { useEffect, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { FaDownload } from "react-icons/fa";
import {
  buttonName,
  monthlyCommison,
  monthlyLending
} from "../../../locales/en";
import { useDispatch, useSelector } from "react-redux";
import { getSalseLead } from "../../../redux/userSalesLeadPersonSlice";
import { countries, timePeriods, viewType } from "../../../utils/data/data";
import styles from "./../../../assets/scss/custom.module.scss";
import ".././reportStyle.scss";
import "react-datepicker/dist/react-datepicker.css";
import { getMonthlyCommissionReportDownload } from "../../../redux/userReportsSlice";

const MonthlySalesFilter = (props) => {
  const { commissionReport, onInputChange, loading } = props;
  const dispatch = useDispatch();
  const { userSlaesLead } = useSelector((state) => state.userSalseLeadPerson);
  const { monthlyCommissionDownloadLoader } = useSelector(
    (state) => state.userReport
  );
  const years_periods = useMemo(
    () => [
      {
        id: 1,
        name: "All",
        value: "All"
      }
    ],
    []
  );

  const viewTypeOptions = useMemo(() => viewType, []);
  const timePeriodOptions = useMemo(() => timePeriods, []);
  const countryOptions = useMemo(() => countries, []);
  const salesLeadOptions = useMemo(() => userSlaesLead || [], [userSlaesLead]);

  const FilterSelectComponent = ({
    label,
    name,
    value,
    onChange,
    disabled,
    options
  }) => (
    <div className="d-flex align-items-center mb-1 mt-1">
      <label className={`${styles.selectStatusLabel}`}>{label}</label>
      <select
        name={name}
        className={`${styles.selectShowStatus} pe-5`}
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {options.map((opt) => (
          <option key={opt.id ?? opt.value} value={opt.value ?? opt.id ?? ""}>
            {opt.name}
          </option>
        ))}
      </select>
    </div>
  );

  FilterSelectComponent.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
      })
    ).isRequired
  };

  FilterSelectComponent.displayName = "FilterSelect";

  const FilterSelect = React.memo(FilterSelectComponent);

  const handleDownload = useCallback(async () => {
    try {
      const payload = {
        viewType: commissionReport.viewType,
        salesLead: commissionReport.salesLeadName,
        periods: commissionReport.period,
        country: commissionReport.country
      };

      const result = await dispatch(
        getMonthlyCommissionReportDownload(payload)
      ).unwrap();

      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      const date = new Date();
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      link.href = url;
      link.setAttribute(
        "download",
        `Sales_Lead_Commission_Report_${formattedDate}.xlsx`
      );

      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch {
      // handle catch here;
    }
  }, [commissionReport, dispatch]);

  useEffect(() => {
    const getSalseLeadData = async () => {
      await dispatch(getSalseLead()).unwrap();
    };
    getSalseLeadData();
  }, [dispatch]);

  return (
    <div className="d-flex align-self-center justify-content-between flex-wrap">
      <div className="d-flex align-self-center flex-wrap">
        <div className="filter d-flex align-self-center  main-filter-bar flex-wrap">
          <FilterSelect
            label={monthlyCommison?.filter.viewType}
            name="viewType"
            value={commissionReport.viewType}
            onChange={onInputChange}
            disabled={loading}
            options={viewTypeOptions}
          />
        </div>

        <div className="d-flex filter_download align-items-center mb-1 mt-1">
          <div className="d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {monthlyCommison?.filter.periods}
            </label>
            <select
              name="period"
              className={`${styles.selectShowStatus}`}
              value={commissionReport.period}
              onChange={onInputChange}
              disabled={loading}
            >
              {(commissionReport.viewType === "Month" ||
                commissionReport.viewType === "Quarter") &&
                timePeriodOptions.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.name}
                  </option>
                ))}

              {commissionReport.viewType === "Year" &&
                years_periods.map((filter) => (
                  <option key={filter.id} value={filter.value}>
                    {filter.name}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className="d-flex filter_download align-items-center mb-1 mt-1">
          <FilterSelect
            label={monthlyCommison?.filter.selectCountry}
            name="country"
            value={commissionReport.country}
            onChange={onInputChange}
            disabled={loading}
            options={countryOptions}
          />
        </div>

        <div className="d-flex filter_download align-items-center mb-1 mt-1">
          <div className="d-flex">
            <label
              htmlFor="Status-sort"
              className={`${styles.selectStatusLabel} d-flex align-self-center `}
            >
              {monthlyCommison?.filter.selectLead}
            </label>

            <select
              name="salesLeadName"
              className={`${styles.selectShowStatus}`}
              value={commissionReport.salesLeadName}
              onChange={onInputChange}
              disabled={loading}
            >
              <option value="">{monthlyLending?.filter?.all}</option>
              {salesLeadOptions.map((filter) => (
                <option key={filter.id} value={filter.id}>
                  {filter.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="text-end">
        <div className="d-flex filter_download align-items-center mb-1 mt-1">
          <button
            className="btn btn-blue"
            onClick={handleDownload}
            disabled={loading || monthlyCommissionDownloadLoader}
          >
            {monthlyCommissionDownloadLoader ? (
              buttonName.loading
            ) : (
              <>
                {buttonName.download} <FaDownload />
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
MonthlySalesFilter.propTypes = {
  commissionReport: PropTypes.object,
  onInputChange: PropTypes.func,
  loading: PropTypes.bool
};
export default MonthlySalesFilter;
